<script>
  import { ActionBar, GridContainer } from "@ObamaFoundation/of-design-system";
  import LoadingIndicator from "$lib/components/LoadingIndicator.svelte";

  export let actionBar = {};
  export let title = "";
  export let subtitle = "";
  export let isLoading = false;
</script>

<div class="embedded-content pt-nav-height-mobile lg:pt-nav-height-desktop">
  <GridContainer>
    <div class="flex sm:flex-col md:flex-row justify-between">
      <div class={isLoading ? "flex items-center" : ""}>
        <h1 class="heading-lg">{title}</h1>
        <h2 class="heading-lg text-grey pb-15">{subtitle}</h2>
      </div>
      {#if isLoading}
        <LoadingIndicator
          containerClasses="justify-center"
          spinnerClasses="w-[4rem] h-[4rem]"
          screenreaderText="Collection order information"
        />
      {/if}
    </div>
    {#if Object.keys(actionBar).length > 0}
      <ActionBar
        text={actionBar.text}
        actions={actionBar.actions}
        showActionItemDataOnMobile={true}
      />
    {/if}
  </GridContainer>
</div>
